export function getGeolocation(lieu, effect) {
    let base = 'https://api-adresse.data.gouv.fr/search/?q='
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
        // Only run if the request is complete
        if (xhr.readyState !== 4) return;
        // Process our return data
        if (xhr.status >= 200 && xhr.status < 300) {
            let json = JSON.parse(xhr.response)
            if (json.features && json.features.length) {
                console.log(json.features.length, ' result(s) found')
                console.log(json.features.map(f => f.properties.label))
                let { coordinates } = json.features[0].geometry
                let [ lon, lat ] = coordinates
                effect(true, {lat, lon}, json)
            } else {
                effect(false, null, json)
            }
        } else {
            console.log('[FAIL]', lieu, effect);
        }
    };
    xhr.open('GET', base + escape(lieu));
    xhr.send();
}
